import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Box from '@mui/material/Box';

export default function MyCard({image, heading, description}) {
  return (
    <Card sx={{ maxWidth: 300,  border: '7px solid var(--orangeCard)', borderRadius: 6}}>
      <Box sx={{display: 'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', p:4}}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="110"
            image={image}
            alt="green iguana"
            sx={{ width: 'auto', margin: "0 auto"}}
          />
          <CardContent sx={{ display: 'flex', flexDirection: 'column',  alignItems: 'center' }}>
            <Typography variant="h6" sx={{fontWeight:'bold'}}>
              {heading}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign:'center' }}>
              {description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Box>
    </Card>
  );
}
